/**
 * xxx機能定義ファイル
 * 概要
 * 更新履歴
 */

/* eslint-disable @typescript-eslint/camelcase */
export const customerStatusId = 'Status';

/** 詳細の初期表示アクション **/
export const customerInitialAction = 'update';
// export const customerDetailInitAction = 'update';

/** 一覧画面 一覧表示テーブルカラム */
export const ColumnList: Array<{ [k: string]: string | number }> = [
  { name: 'i_id', text: '個別', value: 'i_id', order: 1, width: 50 },
  { name: customerStatusId, order: 2, width: 50 },
  { name: 'company_name', order: 3 },
  { name: 'sales_staff', order: 4 },
  { name: 'adress', order: 5 },
  { name: 'visit_date', order: 6 },
  { name: 'customer_staff', order: 7 },
  { name: 'customer_status', order: 8 }
];

// 顧客部署リスト
export const customerDepartmentDetailsHeaders = [
  { text: '詳細', value: 'detail', width: '10' },
  { text: '部署番号', value: 'department_id', width: '10' },
  { text: '部署名', value: 'department_name', width: '80' },
  { text: '担当名', value: 'manager', width: '80' },
  { text: '電話番号', value: 'telephone_number', width: '60' }
];

export const matterBasicDetailsHeaders = [
  { text: '詳細', value: 'detail', width: '10' },
  { text: '案件番号', value: 'project_id', width: '40' },
  { text: '案件名', value: 'project_name', width: '120' },
  { text: '案件ステータス', value: 'status', width: '40' },
  { text: 'サービス種別', value: 'service_type_name', width: '80' }
];

/** 検索パネルのGrid1区間の横幅（%） */
export const SearchPanelColumnWidth = 5;

/** 登録ガイドメッセージ */
export const authorityValidMessage = 'この内容でよろしければ「登録する」を押してください';
export const authorityInvalidMessage = '登録権限を持たないユーザです';

/** 登録・編集完了時の確認ダイアログ */
export const registerFinishText = '登録が完了いたしました';
export const registerFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'routing',
    name: 'toEdit',
    value: '詳細画面へ',
    route: '/customer/edit/:id'
  }
];
export const editFinishText = '顧客管理情報を編集しました';
export const editFinishAction = [
  {
    id: 1,
    color: 'primary',
    type: 'reload',
    name: 'reload',
    value: '閉じる'
  }
];
// 自動採番APIの格納フィールドIDと採番フィールドID
// eslint-disable-next-line @typescript-eslint/no-namespace
namespace autoNumber {
  export const Define: { [k: string]: { [k: string]: string } } = {
    appNumber: {
      displayId: 'customer_application_no',
      autoFieldId: '_autonum_customer_application_no',
      linkDsFieldId: 'customer_application_no'
    },
    customerNumber: {
      displayId: 'customer_no',
      autoFieldId: '_autonum_customer_no',
      linkDsFieldId: 'customer_no'
    }
  };
}
export const AutoNumberDefine = autoNumber.Define;

//検索時の初期表示Option
export const StatusSelectInitialOption: { text: string; value: string[] } = {
  text: '全ステータス',
  value: []
};
export const DetailNotFoundMessage = '明細情報はありませんでした';

export const filterSelect = [
  { key: 'supplier_id', target: 'supplier_staff_id' },
  { key: 'payment_destination_supplier_id', target: 'payment_information_id' },
  { key: 'item_id', target: 'standard_name', isDetail: true }
];

export const bulkMessage: { [k: string]: string } = {
  noItems: 'アイテムを選択してください',
  notMatch: 'アイテムステータスが一致していません',
  apiSuccess: '処理が完了しました',
  apiError: '以下のアイテムの処理が失敗いたしました'
};

// ActionButtonWithSearchPanelに設定(案件新規登録ボタン)
export const CustomerRegisterActionButton = [
  {
    action_id: '',
    action_name: '案件新規登録',
    display_id: '案件新規登録',
    display_order: 0,
    crud_type: '',
    next_status_id: '',
    isDisable: false
  }
];

// ActionButtonWithSearchPanelに設定(案件新規登録ボタン)
export const CustomerDepartmentRegisterActionButton = [
  {
    action_id: '',
    action_name: '部署新規登録',
    display_id: '部署新規登録',
    display_order: 0,
    crud_type: '',
    next_status_id: '',
    isDisable: false
  }
];

export const toolTipsMessage: { [k: string]: string } = {
  customer_toolTipsTextBasicInfoMain: '「顧客基本情報」はお客様の会社単位での基本情報となります',
  customer_toolTipsTextDepartmentList:
    '「部署・拠点一覧」は案件情報に上記の基本情報以外の設置拠点・請求拠点の設定を行うための情報です',
  customer_toolTipsTextMatterList:
    '「案件一覧」は案件内容の情報入力から見積書の作成を行うための情報です'
};

/* eslint-enable */
